import { NavLink } from 'react-router-dom';
import { Package, ShoppingBag, BarChart3, User, LogOut, X } from 'lucide-react';

const items = [
    { label: 'محصولات', path: '/irancharsouq-admin/products', icon: Package },
    { label: 'سفارشات', path: '/irancharsouq-admin/orders', icon: ShoppingBag },
    { label: 'گزارش‌ها', path: '/irancharsouq-admin/reports', icon: BarChart3 },
    { label: 'پروفایل', path: '/irancharsouq-admin/profile', icon: User },
];

export default function IrancharsouqAdminSidebar({ isOpen, onClose, onLogout }) {
    return (
        <aside className={`admin-sidebar glass-sidebar ${isOpen ? 'open' : ''}`}>
            <div>
                {/* هدر سایدبار بدون متن، فقط آیکون */}
                <div className="admin-sidebar-header">
                    <div className="admin-sidebar-brand">
                        <div className="admin-sidebar-logo"><Package size={20} /></div>
                    </div>
                    <button onClick={onClose} className="admin-sidebar-close hidden-mobile" aria-label="بستن منو">
                        <X size={18} />
                    </button>
                </div>
                <nav className="admin-nav">
                    {items.map(({ label, path, icon: Icon, end }) => (
                        <NavLink
                            key={path} to={path} end={end} onClick={onClose}
                            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
                            title={label}
                        >
                            <Icon size={20} className="nav-icon" />
                            <span>{label}</span>
                        </NavLink>
                    ))}
                </nav>
            </div>
            <div className="admin-sidebar-footer">
                <button onClick={onLogout} className="admin-logout-btn" title="خروج از حساب">
                    <LogOut size={20} className="nav-icon" />
                    <span>خروج از حساب</span>
                </button>
            </div>
        </aside>
    );
}